"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _DropDown = _interopRequireDefault(require("@p24/icons/DropDown"));

function _default(palette) {
  return {
    width: 'auto',
    minWidth: 'auto',
    appearance: _DropDown["default"],
    display: 'block',
    labelFontSize: palette.tsXSmall,
    labelLineHeight: palette.tlXSmall,
    fontSize: palette.tsNormal,
    lineHeight: 1.5,
    fontFamily: palette.fontFamily,
    paddingTop: palette.gutter + 'px',
    paddingBottom: palette.gutter + 'px',
    paddingRight: 0,
    paddingLeft: 0,
    listBackground: palette.elPrimary,
    listBoxShadow: "0 6px 10px 0 ".concat(palette.elShadow, ", 0 4px 10px 0 ").concat(palette.elShadow),
    listZIndex: palette.zOverlay,
    listOverflowY: 'auto',
    listOverflowX: 'auto',
    listMaxHeight: 'none',
    listTransformOrigin: 'top',
    listMinWidth: '100%',
    listOffsetTop: 2,
    listOffsetRight: 0,
    listOffsetBottom: 2,
    listOffsetLeft: 0,
    listGapTop: palette.gutter,
    listGapRight: palette.gutter * 3,
    listGapBottom: palette.gutter,
    listGapLeft: palette.gutter,
    listItemColor: palette.tActive,
    listItemBackground: 'transparent',
    listItemPaddingLeft: palette.gutter * 3 + 'px',
    listItemPaddingRight: palette.gutter * 3 + 'px',
    // equal to selector padding by default
    listItemPaddingTop: undefined,
    listItemPaddingBottom: undefined,
    listItemBorderTop: '0 none',
    listItemBorderBottom: '0 none',
    listItemBorderLeft: '0 none',
    listItemBorderRight: '0 none',
    listItemBorder: '0 none',
    listItemHoverBackground: palette.elLightest,
    listItemHoverColor: palette.tActive,
    listItemFocusColor: palette.tActive,
    listItemFocusBackground: palette.elLightest,
    listItemSelectedColor: palette.tAccent,
    listItemSelectedBackground: 'transparent',
    listItemFocusSelectedColor: palette.tAccent,
    listItemFocusSelectedBackground: palette.elLightest,
    listItemHoverSelectedColor: palette.tAccent,
    listItemHoverSelectedBackground: palette.elLightest,
    idleColor: palette.tFilled,
    idlePlaceholder: palette.tHint,
    idleLabelColor: palette.tLabel,
    idleBorderColor: palette.elDivider,
    idleBorderStyle: 'none none solid',
    idleBorderWidth: '1px',
    idleBorderTransform: 'scaleX(0)',
    idleBorderRadius: '0',
    idleBackground: 'transparent',
    idleBoxShadow: 'none',
    idleOutline: 'none',
    idleAppearanceOpacity: 0.38,
    focusColor: palette.tActive,
    focusPlaceholder: palette.tPlaceholder,
    focusLabelColor: palette.tAccent,
    focusBorderColor: palette.elAccent,
    focusBorderStyle: 'none none solid',
    focusBorderWidth: '2px',
    focusBorderTransform: 'scaleX(1)',
    focusBorderRadius: '0',
    focusBackground: 'transparent',
    focusBoxShadow: 'none',
    focusOutline: 'none',
    focusAppearanceOpacity: 0.87,
    hoverColor: palette.tFilled,
    hoverPlaceholder: palette.tHint,
    hoverLabelColor: palette.tLabel,
    hoverBorderColor: palette.elSecondary,
    hoverBorderStyle: 'none none solid',
    hoverBorderWidth: '2px',
    hoverBorderTransform: 'scaleX(1)',
    hoverBorderRadius: '0',
    hoverBackground: 'transparent',
    hoverBoxShadow: 'none',
    hoverOutline: 'none',
    hoverAppearanceOpacity: 0.87,
    disabledColor: palette.tDisabled,
    disabledLabelColor: palette.tLabel,
    disabledPlaceholder: palette.tPlaceholder,
    disabledBorderTransform: 'scaleX(1)',
    disabledBorderStyle: 'none none dotted',
    disabledBorderWidth: '2px',
    disabledBorderColor: palette.elDivider,
    disabledBorderRadius: '0',
    disabledBackground: 'transparent',
    disabledBoxShadow: 'none',
    disabledOutline: 'none',
    disabledAppearanceOpacity: 0.15,
    errorColor: palette.tFilled,
    errorLabelColor: palette.tError,
    errorPlaceholder: palette.tHint,
    errorBorderColor: palette.elError,
    errorBorderStyle: 'none none solid',
    errorBorderWidth: '2px',
    errorBorderTransform: 'scaleX(1)',
    errorBorderRadius: '0',
    errorBackground: 'transparent',
    errorBoxShadow: 'none',
    errorOutline: 'none'
  };
}